import { memo, useCallback, useMemo } from "react";
import { Card, Col, Divider, Form, message, Row } from "antd";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useAddComplimentrySubscriptionMutation } from "../../features/accounting/subscriptionApi";
import { AddComplimentrySubscriptionModel, DurationModel } from "../../entities/subscription";
import { DefaultForm } from "../../components";
import { useGetDurationsQuery, useGetPackagesQuery } from "../../features/accounting/packageAPi";

const AddComplimentrySubscription = memo(() => {
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams();
  const userId = useMemo<string | undefined>(() => (params.recordId ? params.recordId : undefined), [params]);
  const [form] = Form.useForm<AddComplimentrySubscriptionModel>();
  const selectedPackageId = Form.useWatch("packageId", form);

  const [addComplimentrySubscription, addComplimentrySubscriptionStatus] = useAddComplimentrySubscriptionMutation();

  const onFinish = async (values: any) => {
    if (!userId) return;

    let saveModel: AddComplimentrySubscriptionModel = {
      ...values,
      accountId: userId,
    };

    message.loading({ content: "در حال افزودن اشتراک هدیه", key: "addComplimentrySubscription", duration: 0 });
    try {
      await addComplimentrySubscription(saveModel).unwrap();

      message.success({
        content: "عملیات با موفقیت انجام شد",
        key: "addComplimentrySubscription",
        duration: 5,
      });
      navigate("/users", { state: location.state });
    } catch (error: any) {
      message.error({
        content: "ثبت اطلاعات با خطا مواجه شد",
        key: "addComplimentrySubscription",
        duration: 5,
      });
      if (error.status === 403) {
        message.error({
          content: "شما مجوز لازم برای انجام این عملیات را ندارید",
          key: "addComplimentrySubscription",
          duration: 5,
        });
      }
    }
  };

  const durationFilter = useCallback(
    (data: DurationModel[]) => (selectedPackageId ? data.filter((x) => x.packageId === selectedPackageId) : []),
    [selectedPackageId],
  );

  return (
    <DefaultForm onFinish={onFinish} layout="vertical" form={form}>
      <Row gutter={32}>
        <Col xs={24} md={12} xl={8}>
          <Card>
            <DefaultForm.DataSelect
              name="packageId"
              label="بسته"
              query={useGetPackagesQuery}
              displayText={(x) => x.name}
              loadAll={true}
              rules={[{ required: true }]}
            />
            <DefaultForm.DataSelect
              name="durationId"
              label="دوره"
              query={useGetDurationsQuery}
              displayText={(x) => x.name}
              loadAll={true}
              rules={[{ required: true }]}
              filterQueryData={durationFilter}
            />
          </Card>
        </Col>
      </Row>

      <Divider />

      <DefaultForm.SubmitButton loading={addComplimentrySubscriptionStatus.isLoading} />
    </DefaultForm>
  );
});

export default AddComplimentrySubscription;
